import { render, staticRenderFns } from "./ChoicePanelEditor.vue?vue&type=template&id=791c73be&scoped=true"
import script from "./ChoicePanelEditor.vue?vue&type=script&lang=js"
export * from "./ChoicePanelEditor.vue?vue&type=script&lang=js"
import style0 from "./ChoicePanelEditor.vue?vue&type=style&index=0&id=791c73be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c73be",
  null
  
)

export default component.exports